<i18n lang="yaml" locale="en">
  url: Url
  click to edit: Click here to edit.
</i18n>

<i18n lang="yaml" locale="de">
  url: Url
  click to edit: Klicken Sie hier zum Editieren.
</i18n>

<template>
  <section
    v-if="url"
  >
    <iframe
      frameborder="0"
      allow="autoplay, encrypted-media"
      allowfullscreen
      :src="url"
    />
    <div
      v-if="$editMode"
      class="edit-mask"
      :title="$t('click to edit')"
      @click.capture="handleEdit"
    />
  </section>
  <div
    v-else
    @click.capture="handleEdit"
  >
    <placeholder
      v-if="$editMode"
      :message="$t('click to edit')"
    />
  </div>
</template>

<script>
import Placeholder from '@/components/editor/Placeholder'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'iframe',
  extends: BaseModule,
  customStore: translatable,
  components: {
    Placeholder
  },
  props: {
    // eslint-disable-next-line
    _headlineUrl: {
      input: 'heading',
      label: 'url'
    },
    url: {
      type: String,
      input: 'text',
      default: ''
    }
  },
  methods: {
    handleEdit () {
      if (this.$editMode) {
        this.$router.replace({ query: { edit: this.$store.getters.path } })
      }
    }
  }
}
</script>

<style lang="scss">
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  .edit-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
</style>
